import React from "react";

import { Icon } from "@partials";
import { TabType, MOBILE } from "@constants";

import { IconsListProps } from "../../../types";

type FiltersMobileCloseButtonProps = {
  type: TabType;
} & IconsListProps;

const FiltersMobileCloseButton: React.FC<FiltersMobileCloseButtonProps> = ({ iconsList, type }) => {
  const { close } = iconsList;

  return (
    <button
      type="button"
      id={`filters-hide-button-${MOBILE}-${type}`}
      className="pointer absolute top-4 right-4 flex h-[30px] w-[30px] items-center justify-center rounded-full bg-grey-80"
    >
      <Icon
        name={close.name}
        viewBox={close.viewbox}
        alt={close.alt}
        svg={close.svg}
        className="inline h-6 w-6 fill-white"
      />
    </button>
  );
};

export default FiltersMobileCloseButton;
